import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { Vector2D } from "@/lib/rects/vector2d";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ThouCanvas',
    emits: ["mousedown", "mouseup", "mousemove", "click", "dblclick"],
    setup(__props, { emit: __emit }) {
        function get_event_thous(event) {
            if (!(event.currentTarget instanceof SVGSVGElement)) {
                return new Vector2D();
            }
            return new Vector2D(Math.round((event.offsetX / event.currentTarget.clientWidth) * 1000), Math.round((event.offsetY / event.currentTarget.clientHeight) * 1000));
        }
        const emit = __emit;
        function transform_mouse_event(event) {
            const point = get_event_thous(event);
            // mute a useless typescript error
            const event_type = event.type;
            emit(event_type, event, point);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                version: "1.1",
                viewBox: "0 0 1000 1000",
                preserveAspectRatio: "none",
                onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["prevent"])),
                onMousedown: transform_mouse_event,
                onMousemove: transform_mouse_event,
                onMouseup: transform_mouse_event,
                onClick: transform_mouse_event,
                onDblclick: transform_mouse_event
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 32));
        };
    }
});
